export default __webpack_public_path__ + "static/media/Mujer_02_E-Hunter.11dff5e6.png";